export const LABELS_TABLE_ID = 'label-management-labels-table';

export const VALUES_CELL_MAX_VISIBLE = 3;

export const VALUES_MODAL_WIDTH = '480px';

export const LABELS_TABLE_COLUMN_WIDTHS = {
	KEY: '200px',
	DISPLAY_NAME: '200px',
	TYPE: '120px',
	VALUES: '360px',
	ACTIONS: '80px'
} as const;

export const CREATE_BUTTON_COLUMN_WIDTH = '160px';
